<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios'
let _logout = false

export default {
  name: 'App',
  components: {
    
  },
  async created() {
    axios.interceptors.response.use( (response) =>{
      _logout = false
    return response
    },(err)=>{
      // console.log("aqui",err.response)
      if (err.response && err.response.status == 401){
        this.$router.push('/login')
      if(!_logout)
        this.$store.dispatch('logout')
        _logout = true
      }
      return Promise.reject(err)
    })
  }
}
</script>

<style lang="scss">

@import 'design/index.scss';
@import 'design/bancos/icones-bancos-brasileiros.css';

@font-face {
  font-family: 'Berlin Sans FB Local';
  src:  url('design/fonts/BerlinSansFBBold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
}

.month-picker__month.selected{
  background-color: $color-success !important;
  box-shadow: inset 0 0 3px $color-success, 0px 2px 5px rgb(85 176 242 / 20%) !important;
}
.month-picker__container{
  width: 372px !important;
}

@media screen and (max-width:800px){
  .b-sidebar-backdrop {
    top: 0;
    height: auto !important;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100% !important;
 } 
}

</style>
